import { render } from "./OfferDelete.vue?vue&type=template&id=691c81a4&ts=true"
import script from "./OfferDelete.vue?vue&type=script&lang=ts"
export * from "./OfferDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__